/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Запрос для получения данных формы персональной информации
 * @export
 * @interface FxIdWebFeaturesStoreGetPiFormDataRequest
 */
export interface FxIdWebFeaturesStoreGetPiFormDataRequest {
    /**
     * Публичный идентификатор заказа
     * @type {string}
     * @memberof FxIdWebFeaturesStoreGetPiFormDataRequest
     */
    OrderPublicId: string;
}

/**
 * Check if a given object implements the FxIdWebFeaturesStoreGetPiFormDataRequest interface.
 */
export function instanceOfFxIdWebFeaturesStoreGetPiFormDataRequest(value: object): value is FxIdWebFeaturesStoreGetPiFormDataRequest {
    if (!('OrderPublicId' in value) || value['OrderPublicId'] === undefined) return false;
    return true;
}

export function FxIdWebFeaturesStoreGetPiFormDataRequestFromJSON(json: any): FxIdWebFeaturesStoreGetPiFormDataRequest {
    return FxIdWebFeaturesStoreGetPiFormDataRequestFromJSONTyped(json, false);
}

export function FxIdWebFeaturesStoreGetPiFormDataRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdWebFeaturesStoreGetPiFormDataRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'OrderPublicId': json['OrderPublicId'],
    };
}

export function FxIdWebFeaturesStoreGetPiFormDataRequestToJSON(json: any): FxIdWebFeaturesStoreGetPiFormDataRequest {
    return FxIdWebFeaturesStoreGetPiFormDataRequestToJSONTyped(json, false);
}

export function FxIdWebFeaturesStoreGetPiFormDataRequestToJSONTyped(value?: FxIdWebFeaturesStoreGetPiFormDataRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'OrderPublicId': value['OrderPublicId'],
    };
}

